import { render } from "./iconsView.vue?vue&type=template&id=05befa51&scoped=true"
import script from "./iconsView.vue?vue&type=script&lang=js"
export * from "./iconsView.vue?vue&type=script&lang=js"

import "./iconsView.vue?vue&type=style&index=0&id=05befa51&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05befa51"]])

export default __exports__